import { ISalePageDetailV2Response } from '@/api/types';
import { SalePageTopImages } from '@/app/sales/components/topImages';
import { IMediaFileResponse } from '@/types';
import { getCdnUrl } from '@/utils/image';
import { Column } from '@vuddy/components';
import * as styles from './backgroundSection.css';

const defaultAdditionalImages = [
  {
    type: 'VIDEO',
    uuid: '',
    url: getCdnUrl('/images/gacha/sale_page_default.mp4'),
    width: 560,
    height: 560,
  },
];

interface IGachaBackgroundSectionProps {
  salePage: ISalePageDetailV2Response;
}

export const GachaBackgroundSection = ({
  salePage,
}: IGachaBackgroundSectionProps) => {
  return (
    <Column className={styles.wrapper}>
      <SalePageTopImages
        backgroundColor="black"
        salePage={{
          ...salePage,
          additionalImages:
            salePage.additionalImages.length > 0
              ? salePage.additionalImages
              : (defaultAdditionalImages as IMediaFileResponse[]),
        }}
      />
    </Column>
  );
};
